import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: { label: string; value: string }[];
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: [],
};

const getManagerApproveEarlyRegisterSlice = createSlice({
  name: "getManagerApproveEarlyRegister",
  initialState,
  reducers: {
    getManagerApproveEarlyRegisterStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getManagerApproveEarlyRegisterSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getManagerApproveEarlyRegisterFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetManagerApproveEarlyRegister: () => {
      return { ...initialState };
    },
  },
});

export const {
  getManagerApproveEarlyRegisterStart,
  getManagerApproveEarlyRegisterSuccess,
  getManagerApproveEarlyRegisterFailed,
  resetManagerApproveEarlyRegister,
} = getManagerApproveEarlyRegisterSlice.actions;

export default getManagerApproveEarlyRegisterSlice.reducer;
